<template>
  <p class="content-warning">
    <font-awesome-icon
        v-if="icon && icon.length"
        class="content-warning__icon"
        :icon="icon" />
    <span v-if="content" v-html="content"></span>
    <slot v-else></slot>
  </p>
</template>

<script>
export default {
  name: 'content-warning',
  props: {
    content: String,
    icon: {
      type: Array,
      default() {
        return ['fal', 'exclamation-triangle'];
      },
    },
  },
};
</script>

<style scoped lang="scss">
.content-warning {
  color: var(--nxt-color-warning);
  word-break: initial;
  &__icon {
    font-size: 20px;
    margin-right: 10px;
  }
}
</style>
